import { Checkbox, TableCell, TableRow } from 'design-system';

import type { SymbolKey } from '@/entities/symbol';
import type { FactsheetSymbol } from '@/features/factsheet';
import { useFactsheetSelection } from '@/features/factsheet/state/FactsheetSelectionContext';

const LockableCheckbox = ({
  checked,
  modeLocked,
  onLockedClick,
  onCheckedChange
}: {
  checked: boolean;
  modeLocked?: boolean;
  onLockedClick?: () => void;
  onCheckedChange: () => void;
}) => {
  if (!modeLocked) {
    return (
      <Checkbox
        checked={checked}
        onCheckedChange={onCheckedChange}
      />
    );
  }

  return (
    <span className='relative inline-flex'>
      <Checkbox
        readOnly
        checked={checked}
      />
      <span
        data-testid='mode-lock-overlay'
        className='absolute inset-0 z-10 cursor-not-allowed'
        onClick={event => {
          event.stopPropagation();
          onLockedClick?.();
        }}
      />
    </span>
  );
};

const ItemsTableRow = ({ symbol, code }: { symbol: FactsheetSymbol; code: string }) => {
  const selection = useFactsheetSelection();
  const isSymbolSelected = selection?.isSymbolSelected ?? (() => false);
  const toggleSymbolInSelection = selection?.toggleSymbolInSelection ?? (() => {});
  const isSpotLocked = selection?.isSpotLocked ?? false;
  const { timeRef, period, periodType, alias, timeRefDetail } = symbol;
  const selectedSymbol: SymbolKey = {
    Code: code,
    Period: period,
    PeriodType: periodType,
    TimeRef: timeRef
  };

  return (
    <TableRow>
      <TableCell className='border-l-0 p-0 pr-2 pl-2'>
        <div className='flex items-center'>
          <LockableCheckbox
            checked={isSymbolSelected(selectedSymbol)}
            modeLocked={isSpotLocked}
            onCheckedChange={() => toggleSymbolInSelection(selectedSymbol)}
            onLockedClick={() => toggleSymbolInSelection(selectedSymbol)}
          />
        </div>
      </TableCell>
      <TableCell>{code}</TableCell>
      <TableCell>{timeRef}</TableCell>
      <TableCell>{periodType}</TableCell>
      <TableCell>{period}</TableCell>
      <TableCell className='w-1/5'>{alias}</TableCell>
      <TableCell className='w-1/5'>{timeRefDetail}</TableCell>
    </TableRow>
  );
};
export default ItemsTableRow;
